import { EntityRepository, Repository } from "typeorm";
import { LogBookItems } from "../log-book-items.entity";

@EntityRepository(LogBookItems)
export class LogBookItemsRepository extends Repository<LogBookItems> {
    
}